import pizzaKioskAPI from './pizzaKioskApi';

export default pizzaKioskAPI;
